import React from "react";
import { Accordion, Card } from "react-bootstrap";

const SleepStudyFaq = ({ faqData, title }) => {
  return (
    <section className="container brand-logo-wrapper vVedioBlock">
      <div className="container">

        {title && (
          <h2 className="SleepStudyFaq mb-4">
            {title}
          </h2>
        )}

        <Accordion>
          {faqData.map((faq, index) => (
            <Card key={index}>
              <Accordion.Toggle as={Card.Header} eventKey={index.toString()}>
                {faq.question}
              </Accordion.Toggle>

              <Accordion.Collapse eventKey={index.toString()}>
                <Card.Body>{faq.answer}</Card.Body>
              </Accordion.Collapse>
            </Card>
          ))}
        </Accordion>

      </div>
    </section>
  );
};

export default SleepStudyFaq;